<template>
    <card class="mb-5">
        <template slot="body">
            <form @submit.prevent="save" >
                <template>
                    <div v-if="!editable" @click="toggleEdit" class="btn btn-link btn-sm text-blue float-right">
                        <i class="fa fa-edit"></i> Edit
                    </div>
                    <div v-if="editable && !isRequesting" @click="toggleEdit" class="btn btn-link btn-sm text-danger float-right">
                        <i class="fa fa-ban"></i> Cancel
                    </div>
                </template>
                <h6 class="heading-small text-muted">Address Information</h6>
                <div class="row">
                    <div v-if="initialAddress.address.id" class="col-lg-12 mb-4">
                        <google-map @change="syncMapData" :disabled="!editable" :initial-value="initialAddress" :initial-location="initialAddress.position" ></google-map>
                    </div>
                    <div class="col-lg-12">
                        <div v-if="!editable" class="row">
                            <div class="col-lg-11">
                                <div class="text-xs">Unit/House no, Building, Street name</div>
                                <h3 class="font-weight-700 text-default text-sm" v-text="address.specification"></h3>
                            </div>
                            <div class="col-lg-11">
                                <div class="text-xs">Barangay</div>
                                <h3 class="font-weight-700 text-default text-sm" v-text="address.barangay"></h3>
                            </div>
                            <div class="col-lg-6 col-sm-12">
                                <div class="text-xs">City/Municipality</div>
                                <h3 class="font-weight-700 text-default text-sm" v-text="address.city"></h3>
                            </div>
                            <div class="col-lg-5 col-sm-12">
                                <div class="text-xs">Province</div>
                                <h3 class="font-weight-700 text-default text-sm" v-text="address.province"></h3>
                            </div>
                            <div class="col-lg-6">
                                <div class="text-xs">Zipcode</div>
                                <h3 class="font-weight-700 text-default text-sm" v-text="address.zipcode"></h3>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-lg-11">
                                <form-input
                                    placeholder="Unit/House no, Building, Street name"
                                    label="Unit/House no, Building, Street name"
                                    v-model="form.specification"
                                    ref="specification"
                                ></form-input>
                            </div>
                            <div class="col-lg-11">
                                <form-input
                                    label="Barangay"
                                    placeholder="Barangay"
                                    v-model="form.barangay"
                                    ref="barangay"
                                >
                                </form-input>
                            </div>
                            <div class="col-lg-6 col-sm-12">
                                <form-input
                                    placeholder="City/Municipality"
                                    label="City/Municipality"
                                    v-model="form.city"
                                    ref="city"
                                ></form-input>
                            </div>
                            <div class="col-lg-5 col-sm-12">
                                <form-input
                                    placeholder="Province"
                                    label="Province"
                                    v-model="form.province"
                                    ref="province"
                                ></form-input>
                            </div>
                            <div class="col-lg-6">
                                <form-input
                                    placeholder="Zipcode"
                                    label="Zipcode"
                                    v-model="form.zipcode"
                                    ref="zipcode"
                                ></form-input>
                            </div>
                            <div class="col-12 text-right">
                                <button v-if="!isRequesting" type="submit" class="btn btn-warning long">
                                    <i class="fa fa-save mr-1"></i> Save
                                </button>
                                <button v-else type="button" disabled class="disabled btn btn-warning long">
                                    <i class="fas fa-spin fa-spinner mr-2"></i> Please wait
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import Form from "@models/components/Form";

export default {
    name: "AddressSection",

    computed: {
        address() {
            return this.$store.getters.address || {};
        },
        initialAddress() {
            return {
                address: { ...this.address },
                position: {
                    lat: parseFloat(this.address.latitude || 0),
                    lng: parseFloat(this.address.longitude || 0),
                    radius: 0,
                }
            };
        },
    },

    data() {
        return {
            editable: false,
            isRequesting: false,
            form: {
                id: "",
                specification: "",
                barangay: "",
                city: "",
                province: "",
                zipcode: "",
                latitude: "",
                longitude: "",
                country: "",
            },
        };
    },

    methods: {
        syncMapData(payload) {
            if  (!this.editable) {
                return;
            }
            this.form.barangay = payload[0].address.barangay;
            this.form.city = payload[0].address.city;
            this.form.country = payload[0].address.country;
            this.form.latitude = payload[0].position.lat;
            this.form.longitude = payload[0].position.lng;
            this.form.province = payload[0].address.province;
            this.form.zipcode = payload[0].address.zipcode;
        },

        toggleEdit() {
            (this.editable = !this.editable)
                ? null
                : this.form.resetData();
        },
        
        initializeAddress() {
            this.form = new Form({
                id: this.address.id,
                specification: this.address.specification,
                barangay: this.address.barangay,
                city: this.address.city,
                province: this.address.province,
                zipcode: this.address.zipcode,
                latitude: this.address.latitude,
                longitude: this.address.longitude,
                country: this.address.country,
            });
        },

        async save() {
            if (!(await this.confirm("Are you sure you want to save this data?", "")).value) {
                return;
            }
            this.isRequesting = true;
            this.$store.dispatch("updateAddress", { data: this.form.getData() })
                .then(response => this.saved(response))
                .catch(error => this.failedToSave(error))
                .finally(() => (this.isRequesting = false));
        },

        saved(response) {
            this.form.save();
            this.editable = false;
            this.promptMessage(response.data.message.message, "");
            this.$emit("updated", response.data.result.address);
        },

        failedToSave(error) {
            console.log(error);
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [mixins],
}
</script>